export enum Datatype {
    TEXT = "Text",
    NUMBER = "Integer",
    BOOLEAN = "Boolean",
    DATE = "Date",
    DATETIME = "DateTime",
    MENU = "PickList",
    BLOB = "Blob",
    DECIMAL="decimal"
}
